import React, {Component} from 'react';
import { Row, Col, Form, message, Input, Select, DatePicker, Checkbox} from 'antd';
import ApiService from '../../actions/apiService';
import { fetchCategories } from '../../actions/categories';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;
class NewFormPost extends Component {
  
  state = {
    categoryid: '',
    title: '',
    postdate: '',
    vimeoVideoID: '',
    Description: '',
    categories: [],
    isDefaultTitle: false,
    
  }
  
  async componentWillMount() {
    const categories = await fetchCategories()
    if (categories && categories.data && categories.data.data) {
      const data = categories.data.data.categories || [];
      this.setState({
        categories: data,
      })
    }
  }
  
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const data = {
          categoryid: values.categoryid,
          title: this.state.isDefaultTitle ? '' : values.title,
          postdate: values.postdate,
          vimeoVideoID: values.vimeoVideoID,
          Description: values.Description,
          isDefaultTitle: this.state.isDefaultTitle
        }
        const profileData = await ApiService.postMethod('/admin/post', data);
        if (profileData && profileData.status === 200) {
          message.success('Post saved successfully!');
        } else {
          message.error('Something went wrong!');
        }
      }
    })
  }
  
  render() {
    const { getFieldDecorator } = this.props.form;
    const { categories, isDefaultTitle } = this.state;
    return (
        <Row gutter={16}>
          <Col gutter={16} sm={24}>
            <Form layout={'vertical'} onSubmit={this.handleSubmit}>
              <FormItem label='Select Category'>
                {getFieldDecorator('categoryid', {
                  initialValue: '',
                  rules: [{
                    required: true,
                    message: 'Please Select category!',
                  }],
                })(
                  <Select>
                    <Option value='' disabled>Select Category</Option>
                    {
                      categories.map(cat => <Option key={cat.id} value={cat.id}>{cat.name}</Option>)
                    }
                  </Select>
                )}
              </FormItem>
              <FormItem>
                <Checkbox checked={isDefaultTitle} onChange={(event) => this.setState({ isDefaultTitle: event.target.checked })}>Use default title?</Checkbox>
              </FormItem>
              {!isDefaultTitle &&
                <FormItem label="Title">
                  {getFieldDecorator('title', {
                    rules: [{
                      required: true,
                      message: 'Please input Title!',
                      whitespace: true
                    }],
                  })(
                    <Input placeholder="Title"/>
                  )}
                </FormItem>
              }
              <FormItem label="Post Date">
                {getFieldDecorator('postdate', {
                  rules: [{
                    required: true,
                    message: 'Please input Post Date!',
                  }],
                })(
                  <DatePicker />
                )}
              </FormItem>
              <FormItem label="vimeo Video ID">
                {getFieldDecorator('vimeoVideoID', {
                  rules: [{
                    message: 'Please input vimeo Video ID!',
                    whitespace: true
                  }],
                })(
                  <Input placeholder="vimeo Video ID"/>
                )}
              </FormItem>
              <FormItem label="Description">
                {getFieldDecorator('Description', {
                  rules: [{
                    message: 'Please input Description!',
                    whitespace: true
                  }],
                })(
                  <TextArea placeholder="Description" rows={3} autosize={{maxRows: 3}}/>
                )}
              </FormItem>
              <Col sm={24} style={{textAlign: 'right'}}>
                <button type="submit" style={{width: '200px', background: '#3190ff', color: '#fff'}} className="ant-btn ant-btn-submit" onClick={this.handleSubmit}>Save</button>
              </Col>
            </Form>
          </Col>
        </Row>
    )
  }
}
const NewPost = Form.create()(NewFormPost);
export default NewPost;





// WEBPACK FOOTER //
// ./src/components/Admin/newPost.js